const DURATION = 12 * 60 * 60; // 12 hours = 43,200 seconds
const PST_OFFSET = 8 * 60 * 60; // PST is fixed UTC-8 (not DST-adjusted), so boundaries land on 12am/12pm PST

if (!customElements.get('util-countdown')) {
  class UtilCountdown extends HTMLElement {
    constructor() {
      super();
      this.countdown = this.querySelector('.util-countdown');
      this.numbersStyle = this.dataset.numbersStyle || '';
      this.tick();
    }

    tick() {
      const now = Math.floor(Date.now() / 1000) - PST_OFFSET;

      const remainingSeconds = DURATION - (now % DURATION);
      const distance = remainingSeconds * 1000;

      // Time calculations
      const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0').split('');
      const hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0').split('');
      const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0').split('');
      const seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0').split('');

      const html = `
        <div class="group days">
          <div class="numbers flex ${this.numbersStyle}">
            <span>${days[0]}</span><span>${days[1]}</span>
          </div>
          <div class="small-label">${lngg?.util_countdown_js__days_label || 'Days'}</div>
        </div>
        <div class="dash">:</div>

        <div class="group hours">
          <div class="numbers flex ${this.numbersStyle}">
            <span>${hours[0]}</span><span>${hours[1]}</span>
          </div>
          <div class="small-label">${lngg?.util_countdown_js__hours_label || 'Hours'}</div>
        </div>
        <div class="dash">:</div>

        <div class="group minutes">
          <div class="numbers flex ${this.numbersStyle}">
            <span>${minutes[0]}</span><span>${minutes[1]}</span>
          </div>
          <div class="small-label">${lngg?.util_countdown_js__minutes_label || 'Minutes'}</div>
        </div>
        <div class="dash">:</div>

        <div class="group seconds">
          <div class="numbers flex ${this.numbersStyle}">
            <span>${seconds[0]}</span><span>${seconds[1]}</span>
          </div>
          <div class="small-label">${lngg?.util_countdown_js__seconds_label || 'Seconds'}</div>
        </div>
      `;

      if (this.countdown) {
        this.countdown.innerHTML = html;
      }

      // Update every second
      setTimeout(this.tick.bind(this), 1000);
    }
  }

  customElements.define('util-countdown', UtilCountdown);
}